const getEventTypeName = (id, settings) => {
    const eventTypes = settings?.form_settings?.event_types?.items

    if (!eventTypes || !eventTypes.hasOwnProperty(id)) {
        return null
    }

    return eventTypes[id].event_type_name || null
}

export default getEventTypeName